import React from 'react';
import { compose } from 'ramda';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import classnames from 'classnames/bind';
import styleFile from './SelectCountry.js';
import RichText from '@synergycms_core/components/generic/RichText';
import SelectField from '@synergycms_core/components/generic/Form/SelectField.jsx';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { keyIn } from '@synergycms_core/utils/utils';
import { List } from 'immutable';

const immutablePick = objectMap => (...keys) => objectMap.filter(keyIn(...keys));

const CountryOption = compose(
  withThemeJSS({ styleFile, displayName: 'SelectCountry' }),
  withContent('countryFlags'))(props => {
  const { classes } = props.theme.styles;
  let cx = classnames.bind(classes);
  return (
    <div {...props.innerProps} className={cx('row', 'test')}>
      <RichText
        innerStyle={['roboto16Black', cx({ isFocused: props.isFocused, isSelected: props.isSelected })]}
        text={
          props.data.get('name') + (props.data.get('phone_prefix') ? ' (+' + props.data.get('phone_prefix') + ')' : '')
        }
        icon={{
          backgroundImage: props.content.getCountryFlags?.(props.data.get('alpha2')),
          innerStyle: ['size12', 'marginRight5', 'iconFlag']
        }}
      />
    </div>
  );
});

const CountrySelected = compose(
  withThemeJSS({ styleFile, displayName: 'SelectCountry' }),
  withContent('countryFlags'))(props => {
  const { classes } = props.theme.styles;
  let cx = classnames.bind(classes);
  return (
    <div {...props.innerProps} className={cx('row', 'test')}>
      <RichText
        innerStyle={['roboto16Black', cx({ isFocused: props.isFocused, isSelected: props.isSelected })]}
        text={props.data.get('phone_prefix') ? '+' + props.data.get('phone_prefix') : props.data.get('name')}
        icon={{
          backgroundImage: props.content.getCountryFlags?.(props.data.get('alpha2')),
          innerStyle: ['size12', 'marginLeft5', 'iconFlag']
        }}
      />
    </div>
  );
});

const SelectCountry = props => {
  const { defaultCountry, countries, theme, arrowPosition, hidePhonePrefix } = props;
  const { classes } = theme.styles;
  let options = countries;
  let defaultValue = defaultCountry;
  if (hidePhonePrefix) {
    options = options.reduce((options, option) => {
      options = options.push(immutablePick(option)('alpha2', 'name', 'translations'));
      return options;
    }, List());
    defaultValue = immutablePick(defaultValue)('alpha2', 'name', 'translations');
  }

  return (
    <div className={classes.selectBox}>
      <SelectField
        classNamePrefix={'shit'}
        getOptionLabel={option => option.get('name')}
        getOptionValue={option => option.get('alpha2')}
        defaultValue={defaultValue}
        styles={{
          control: base => ({
            ...base,
            height: '100%',
            border: 'none',
            position: 'relative'
          }),
          SingleValue: base => ({
            ...base,
            height: '100%',
            verticalAlign: 'middle'
          }),
          menu: base => {
            return {
              ...base,
              width: 'auto'
            };
          },
          menuList: base => {
            return {
              ...base,
              width: 'auto',
              overflowX: 'hidden'
            };
          },
          input: base => {
            return {
              ...base,
              position: 'absolute'
            };
          },
          valueContainer: base => {
            return {
              ...base,
              height: '30px'
            };
          },
          indicatorSeparator: base => {
            return {
              ...base,
              display: 'none'
            };
          },
          indicatorsContainer: base => {
            return {
              ...base,
               cursor: 'pointer',
              position: 'absolute',
              top: 0,
              right: arrowPosition !== 'AR' ? -4 : 'auto',
              left: arrowPosition !== 'AR' ? 'auto' : -4,
              bottom: 0,
              '&:lang(ar)':{
                right:'auto',
                left:'-4px'
              }
            };
          },
          dropdownIndicator: base => ({
            ...base,
            color: theme.themeValues.mainColor,
            '&:hover': {
              color: theme.themeValues.mainColor
            }
          })
        }}
        model={'country'}
        components={{ Option: CountryOption, SingleValue: CountrySelected }}
        innerStyle={[classes.inputSelect, classes.countries]}
        options={options}
      />
    </div>
  );
};

export default compose(withThemeJSS({ styleFile, link: true, displayName: 'SelectCountry' }))(SelectCountry);
